import { searchCommonConfig } from './common'

export const searchConfig = {
  ...searchCommonConfig,
  colors: {
    inputBg: '#FFFFFF',
    startReadingBg: 'linear-gradient(135deg, #F492AC 0%, #E05A7E 100%)',
    isLight: true,
    cardPadding: '12px',
    cardBorder: '1px solid #F5E4EA',
    cardBg: '#FFFFFF',
  },
}
